<template>
	<div class="inner-page add-user">
		<AppHead title="Create new user" />

		<PageHeader 
			title="Add User"
			desc="Add a new user to the Document Room"
			:hasButton="false"
			:showHelper="true"
			helpTitle="Adding a new user"
			helpDesc="Fill out the form and assign a user level to add a new user to the Document Room. Admin users will have access to ALL Cases. Regular users only have access to their own Cases."
			:hr="true"
			/>

		<InputGroup
			title="New User Details"
			desc="Please fill in all fields to create a new user."
			>

			<ValidationErrors />
			
			<InputText
				label="First Name"
				type="text"
				v-model="form.firstName"
				autocomplete="disabled"
				/>
			<InputText
				label="Surname"
				type="text"
				v-model="form.surname"
				autocomplete="disabled"
				/>
			<InputText
				label="Phone"
				type="text"
				v-model="form.phone"
				autocomplete="disabled"
				/>
			<InputText
				label="Email"
				type="email"
				v-model="form.email"
				autocomplete="disabled"
				/>

		</InputGroup>

		<InputGroup
			title="Notification Preferences"
			desc="How should the user be contacted about updates to cases they are assigned to?"
			>
			<InputFancyRadio 
				label="Notification Preferences"
				:options="contactPrefOptions"
				id="contactPref"
				v-model="form.contact_pref"
				/>
		</InputGroup>

		<InputGroup
			title="User Type"
			desc="Please select either Admin or User. Please note: Admins can view ALL Cases. Assign with caution."
			>
			<InputFancyRadio 
				label="Select the level of authorisation"
				:options="authLevels"
				id="privilegelevel"
				v-model="form.user_type"
				/>
		</InputGroup>

		<InputGroup
			title="Team"
			desc="Please assign the user to a team, or to skip adding them to a team just leave 'Unassigned' selected."
			>
			<InputFancyRadio 
				label="Select a team to assign the user to"
				:options="selectableTeams"
				id="assignedTeam"
				v-model="form.team"
				/>
		</InputGroup>

		<InputGroup
			title=""
			desc=""
			:skipWhiteBox="true"
			:noLine="true"
			:buttonBox="true"
			>
			<Button
				label="Create"
				color="green"
				size="regular"
				icon="plus" 
				@click="submit"
				/>

			<Button
				label="Cancel"
				color="white"
				size="regular"
				icon="chevron-left" 
				@click="cancel"
				/>
		</InputGroup>

	</div>
</template>

<script>
import AppHead from "@/Components/AppHead"
import AppLayout from "@/Layouts/AppLayout.vue"
import PageHeader from "@/Components/PageHeader"
import InputGroup from "@/Components/InputGroup"
import InputText from "@/Components/InputText"
import InputFancyRadio from "@/Components/InputFancyRadio"
import Button from "@/Components/Button"
import ValidationErrors from "@/Components/ValidationErrors"

export default {
	components: {
		AppHead,
		PageHeader,
		InputGroup,
		InputText,
		InputFancyRadio,
		ValidationErrors,
		Button
	},
	layout: AppLayout,
	props: {
		teams: {
			type: Object,
			default: {}
		}
	},
	data: () => {
		return {
			authLevels: [
				{
					value: 'admin',
					text: 'Meshworks Admin',
					desc: 'Can view and edit any of the cases, across any of the distributor teams. Can also change user account settings.'
				},
				{
					value: 'global_viewer',
					text: 'Meshworks Viewer',
					desc: 'Can view any of the cases, across any distributor teams.'
				},
				{
					value: 'team_admin',
					text: 'Distributor Admin',
					desc: 'Can view and edit any cases within the distributor teams.'
				},
				{
					value: 'team_user',
					text: 'Distributor User',
					desc: 'Can only view owned cases within a distributor team. Can create new users, can create new cases, has limited access to the admin panel.'
				},
				{
					value: 'viewer',
					text: 'Viewer',
					desc: 'Can only view assigned cases.'
				},
				{
					value: 'user',
					text: 'User',
					desc: 'Can view and edit owned cases, but the cannot view other cases by default. However, they can view other cases in their distributor team if designated by a distributor admin or Meshworks admin (i.e., they can be added to the list of viewers or editors to a case)'
				}
			],
			contactPrefOptions: [
				{
					value: 'email',
					text: 'Email'
				},
				// {
				//   value: 'whatsapp',
				//   text: 'WhatsApp'
				// },
				{
					value: 'sms',
					text: 'SMS'
				},
				{
					value: false,
					text: 'Do not notify',
					desc: 'Selecting this option will mean the user will not be updated about cases and will need to login to check progress'
				}
			],
			form: {
				firstName: null,
				surname: null,
				// name: null,
				phone: null,
				email: null,
				user_type: 'user',
				contact_pref: false,
				team: false
			}
		}
	},
	methods: {
		submit(){
			let count = 0
			for(let field in this.form){
				let thisField = this.form[field]
				if(thisField === null || thisField === ''){
					break
				}
				count++
			}

			if(Object.keys(this.form).length == count){
				this.$inertia.post('/admin/add-user', {
					firstName: this.form.firstName,
					lastName: this.form.surname,
					email: this.form.email,
					phone: this.form.phone,
					contact_pref: this.form.contact_pref,
					user_type: this.form.user_type,
					team: this.form.team
				})
			}else{
				alert(`Please complete all fields`)
			}
		},
		cancel(){
			history.back()
		}
	},
	computed: {
		selectableTeams(){
			let teams = []
			teams.push({
				value: false,
				text: '- Unassigned -'
			})
			for(let team of this.teams){
				teams.push({
					value: team.id,
					text: team.name
				})
			}

			return teams
		}
	}
};
</script>

<style lang="sass" scoped>

// .add-user

</style>